export interface ILineItem {
    id: number;
    entityType: number;
    entityTypeId: number;
    expenseType: number;
    description?: string;
    amount: number;
    receiptFileId?: number;
    createdDateTime: string;
    lastUpdated?: string;
    reviewRequired: boolean;
    expenseDate?: string;
    receiptFileName?: string;
    notes?: string;
    isCaregiverExpense?: boolean;
    numberOfNights?: number;
    tripId?: number;
}

